import AxiosClient from "../../services/axios.services";

class DivisionPersonalServices {
  getDivisionPersonals = (params, iType) =>
    AxiosClient.get(
      iType === 1
        ? "/api/app/Formal_Division_Personal/"
        : "/api/app/Funcional_Division_Personal/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  saveDivisionPersonal = (data, iType) =>
    AxiosClient.post(
      iType === 1
        ? "/api/app/Formal_Division_Personal/"
        : "/api/app/Funcional_Division_Personal/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editDivisionPersonal = (id, data, iType) =>
    AxiosClient.put(
      iType === 1
        ? `/api/app/Formal_Division_Personal/${id}/`
        : `/api/app/Funcional_Division_Personal/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteDivisionPersonal = (id, iType) =>
    AxiosClient.delete(
      iType === 1
        ? `/api/app/Formal_Division_Personal/${id}/`
        : `/api/app/Funcional_Division_Personal/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new DivisionPersonalServices();
